export default __webpack_public_path__ + "static/media/address.a1669d6e.png";